
































































import Vue from "vue";

import Step1 from "@/components/guide/step1.vue";
import Step2 from "@/components/guide/step2.vue";
import Step3 from "@/components/guide/step3.vue";
import Step4 from "@/components/guide/step4.vue";
import Step5 from "@/components/guide/step5.vue";
import Step6 from "@/components/guide/step6.vue";
import Step7 from "@/components/guide/step7.vue";
import Step8 from "@/components/guide/step8.vue";
import Step9 from "@/components/guide/step9.vue";
import Step10 from "@/components/guide/step10.vue";

export default Vue.extend({
  name: "SelfInstallGuide",
  components: {
    Step1,
    Step2,
    // Step2: () => import("./guide/step2.vue"),
    Step3,
    Step4,
    Step5,
    Step6,
    Step7,
    Step8,
    Step9,
    Step10,
  },
  data: () => ({
    currentStep: 1,
    totalSteps: 10,
  }),
  methods: {
    nextStep() {
      if (this.currentStep >= this.totalSteps) return;
      this.currentStep++;
      this.$vuetify.goTo(0);
    },
    prevStep() {
      if (this.currentStep < 1) return;
      this.currentStep--;
      this.$vuetify.goTo(0);
    },
    goToStep(stepNumber: number) {
      console.log(stepNumber)
      this.currentStep = stepNumber;
      this.$vuetify.goTo(0);
    }
  },
});
